import { Reveal } from "@/lib/motion";

const clients = ["Coca-Cola", "Brita", "LEGO", "Shopify", "Polka Dot", "Tree Hut", "Sandoz", "TD"];

export default function Clients() {
  return (
    <section className="mx-auto max-w-[1600px] px-6 py-24 md:px-10 md:py-32" data-testid="clients">
      <Reveal className="mb-14 text-center">
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-white/40">
          Trusted by teams that can't afford a bad show
        </span>
      </Reveal>
      <div className="grid grid-cols-2 gap-y-12 md:grid-cols-4">
        {clients.map((c, i) => (
          <Reveal key={c} delay={(i % 4) * 0.06} className="flex items-center justify-center">
            <span className="font-display text-2xl font-bold uppercase tracking-tight text-white/35 transition-colors duration-300 hover:text-white md:text-3xl">
              {c}
            </span>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
